import { motion } from "framer-motion";

//STYLES
import { ContainerPrazo } from "./styles";
import { transition_default } from "../../../../../../utils";
import { DonutChartPrazosSvg } from "./components/chart";

//PROPS
interface Props {
    dados_prazo: number[];
    qtd_prazos: number[];
}

export const Prazos: React.FC<Props> = ({ dados_prazo, qtd_prazos }) => {
    return (
        <ContainerPrazo
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{...transition_default, delay: 0.2}}
        >
            <p className="Prazo__title">Execuções</p>

            <div className="Prazo__chart">
                <DonutChartPrazosSvg values={dados_prazo} quantidades={qtd_prazos} />
            </div>
            
            <div className="Prazo__labels">
                <div className="Prazo__labels__item">
                    <div className="Prazo__labels__item__circle" style={{background:'#7ebc61'}} />
                    <span className="Prazo__labels__item__lebel">No prazo</span>
                </div>
                <div className="Prazo__labels__item">
                    <div className="Prazo__labels__item__circle" style={{background: "#FFD700"}}/>
                    <span className="Prazo__labels__item__lebel">Adiantado</span>
                </div>
                <div className="Prazo__labels__item">
                    <div className="Prazo__labels__item__circle" style={{background: "#DC143C"}} />
                    <span className="Prazo__labels__item__lebel">Atrasado</span>
                </div>
            </div>

        </ContainerPrazo>
    )
};